import { useState } from "react";
import ModuleView from "@/components/shieldx/ModuleView";
import { Panel } from "@/components/shieldx/Primitives";
import { apiPost } from "@/lib/shieldx";
import { KeySquare, Play } from "lucide-react";

const DEC = { ALLOW: "text-emerald-400", DENY: "text-rose-300" };

export default function ZKAuthorization() {
  const [form, setForm] = useState({ proof_status: "VALID", scope_ok: true, revoked: false, expired: false });
  const [result, setResult] = useState(null);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const run = async () => setResult(await apiPost("/zk/verify", form));
  return (
    <ModuleView name="zk-authorization" icon={KeySquare}>
      <Panel title="Zero-Knowledge Proof Verification" desc="Prove authority, reveal nothing unnecessary — fail closed" className="mt-4" testid="zk-tester">
        <div className="flex flex-wrap items-end gap-4">
          <div><label className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Proof Status</label>
            <select data-testid="zk-proof" value={form.proof_status} onChange={(e) => set("proof_status", e.target.value)} className="mt-1.5 rounded-lg border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-200">{["VALID", "INVALID"].map((o) => <option key={o}>{o}</option>)}</select></div>
          {[["scope_ok", "In Scope"], ["revoked", "Revoked"], ["expired", "Expired"]].map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 pt-5 text-xs text-slate-300"><input type="checkbox" data-testid={`zk-${k}`} checked={form[k]} onChange={(e) => set(k, e.target.checked)} className="h-4 w-4 accent-blue-600" /> {l}</label>
          ))}
          <button onClick={run} data-testid="zk-run" className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500"><Play className="h-4 w-4" /> Verify</button>
        </div>
        {result && (
          <div className="mt-4 rounded-lg border border-slate-800 bg-slate-950/50 p-4" data-testid="zk-result">
            <div className="flex items-center justify-between"><span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{result.disclosure}</span><span className={`font-display text-xl font-bold ${DEC[result.decision] || "text-slate-200"}`}>{result.decision}</span></div>
            <p className="mt-1.5 text-sm text-slate-300">{result.reason}</p>
            <p className="mt-2 font-mono text-[11px] text-slate-500">claim: "{result.claim}" · {result.trace.join(" · ")}</p>
          </div>
        )}
      </Panel>
    </ModuleView>
  );
}
